import { Stack, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomChip } from 'src/shared/components/organisms/customChip';
import { IncomingBankPaymentStatusEnum } from 'src/shared/models/enums/incomingBankPaymentStatus.enum';

type IncomingBankPaymentStatusesProps = {
  status: number;
  chipSize: 'small' | 'medium' | undefined;
};

export const IncomingBankPaymentStatuses = (props: IncomingBankPaymentStatusesProps) => {
  const { status, chipSize } = props;
  const { t } = useTranslation(['invoice']);
  return (
    <Stack direction='row' spacing={1} sx={{ '& .MuiChip-filled ': { borderRadius: 1 } }}>
      {status === IncomingBankPaymentStatusEnum.Matched && (
        <Tooltip describeChild title={`${t('invoice:incomingBankPaymentStatus.Matched')}`} arrow>
          <CustomChip label={t('invoice:incomingBankPaymentStatus.Matched')} color='success' size={chipSize} />
        </Tooltip>
      )}
      {status === IncomingBankPaymentStatusEnum.UnMatched && (
        <Tooltip describeChild title={`${t('invoice:incomingBankPaymentStatus.UnMatched')}`} arrow>
          <CustomChip label={t('invoice:incomingBankPaymentStatus.UnMatched')} color='error' size={chipSize} />
        </Tooltip>
      )}
      {status !== IncomingBankPaymentStatusEnum.Matched && status !== IncomingBankPaymentStatusEnum.UnMatched && (
        <Tooltip describeChild title={`${t('invoice:incomingBankPaymentStatus.UnHandled')}`} arrow>
          <CustomChip label={t('invoice:incomingBankPaymentStatus.UnHandled')} color='grey' size={chipSize} />
        </Tooltip>
      )}
    </Stack>
  );
};
